<template>
  <el-dialog :visible.sync="open"
             width="50%"
             :before-close="handleClose"
             :close-on-click-modal="false"
             :title="title"
             @close="closeDialog">
    <el-card shadow="never"
             class="card-center">
      <!-- 表单 -->
      <el-form size="small"
               label-width="90px"
               :model="form"
               ref="ruleForm">
        <el-row :gutter="50">
          <el-col :span="24">
            <el-form-item label="分组名称"
                          prop="grpinfo.custGrpName"
                          :rules="[
                { required: true, message: '请输入分组名称', trigger: 'blur' },
                {
                  min: 1,
                  max: 15,
                  message: '长度在 1 到 15 个字符',
                  trigger: 'blur',
                },
              ]">
              <el-input v-model="form.grpinfo.custGrpName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="24">
            <el-form-item label="分组类型"
                          :rules="{
                required: true,
                message: '请选择分组类型',
                trigger: 'change',
              }"
                          prop="grpinfo.grpKind">
              <el-select v-model="form.grpinfo.grpKind"
                         style="width: 100%">
                <el-option v-for="item in fenZhuOptions"
                           :key="item.value"
                           :value="item.value"
                           :label="item.label"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="24">
            <el-form-item label="分组描述"
                          prop="grpinfo.remark"
                          :rules="[
                { required: true, message: '请输入分组描述', trigger: 'blur' },
                {
                  min: 1,
                  max: 20,
                  message: '长度在 1 到 20 个字符',
                  trigger: 'blur',
                },
              ]">
              <el-input v-model="form.grpinfo.remark"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 0000 -->
        <el-row :gutter="50">
          <el-col :span="24">
            <el-form-item label="筛选条件">
              <el-checkbox v-model="form.line[0].condiField"
                           :true-label="1"
                           :false-label="-1"
                           @change="leveCast">办卡门店</el-checkbox>
              <el-button style="margin-right: 0.625rem"
                         size="mini"
                         @click="selectStoreBtn1">选择门店</el-button>
              <el-radio v-model="form.line[0].value2"
                        :label="'1'">包含</el-radio>
              <el-radio v-model="form.line[0].value2"
                        :label="'2'">排除</el-radio>
              <!-- <el-form-item prop="listOfSomeStoreslStr">
                <textarea
                  style="width: 100%"
                  rows="5"
                  readonly
                  v-model="form.listOfSomeStoreslStr"
                ></textarea>
              </el-form-item> -->
              <div class="xzBox">
                <ul style="overflow: auto"
                    v-for="(item, index) in newApp"
                    :key="index">
                  <li>{{ item.lable }}</li>
                </ul>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="24">
            <el-form-item label="">
              <el-checkbox v-model="form.line[1].condiField"
                           :true-label="2"
                           :false-label="-2"
                           @change="levecur">维护门店</el-checkbox>
              <el-button style="margin-right: 0.625rem"
                         size="mini"
                         @click="selectStoreBtn2">选择门店</el-button>
              <el-radio v-model="form.line[1].value2"
                        :label="'1'">包含</el-radio>
              <el-radio v-model="form.line[1].value2"
                        :label="'2'">排除</el-radio>
              <!-- 门店信息 -->
              <!-- <el-form-item prop="listOfSomeStoreslStr1">
                <textarea
                  style="width: 100%"
                  rows="5"
                  readonly
                  v-model="form.listOfSomeStoreslStr1"
                ></textarea>
              </el-form-item> -->
              <div class="xzBox">
                <ul style="overflow: auto"
                    v-for="(item, index) in newArr"
                    :key="index">
                  <li>
                    <div style="border: #999">{{ item.lable }}</div>
                  </li>
                </ul>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="6">
            <el-form-item>
              <el-checkbox v-model="form.line[2].condiField"
                           :true-label="3"
                           false-label="-3"
                           @change="handVant">会员等级</el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="18">
            <el-form-item>
              <el-checkbox-group v-model="levelList"
                                 :disabled="form.line[2].condiField == 3 ? false : true">
                <el-checkbox v-for="item in checkbooksData"
                             :key="item.levelID"
                             :value="item.levelID"
                             :label="item.levelID">
                  {{ item.levelName_cn }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="6">
            <el-form-item>
              <el-checkbox v-model="form.line[3].condiField"
                           :true-label="4"
                           false-label="-4">会员积分</el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="18">
            <el-form-item label="">
              <div class="flex-between">
                <span>从</span>
                <el-input style="width: 45%"
                          v-model="form.line[3].value1"
                          :disabled="form.line[3].condiField == 4 ? false : true"
                          oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input style="width: 45%"
                          v-model="form.line[3].value2"
                          :disabled="form.line[3].condiField == 4 ? false : true"
                          oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="6">
            <el-form-item label="">
              <el-checkbox-group v-model="form.line[4].condiField">
                <el-checkbox :true-label="5"
                             false-label="-5">首次升级VIC距今天数</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="18">
            <el-form-item>
              <div class="flex-between">
                <span>从</span>
                <el-input style="width: 45%"
                          v-model="form.line[4].value1"
                          :disabled="form.line[4].condiField == 5 ? false : true"
                          oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input style="width: 45%"
                          v-model="form.line[4].value2"
                          :disabled="form.line[4].condiField == 5 ? false : true"
                          oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="6">
            <el-form-item>
              <el-checkbox-group v-model="form.line[5].condiField">
                <el-checkbox :true-label="6"
                             false-label="-6">R(最近消费日距今天数)</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="18">
            <el-form-item>
              <el-form-item label="">
                <div class="flex-between">
                  <span>从</span>
                  <el-input style="width: 45%"
                            v-model="form.line[5].value1"
                            :disabled="form.line[5].condiField == 6 ? false : true"
                            oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
                  <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                  <el-input style="width: 45%"
                            v-model="form.line[5].value2"
                            :disabled="form.line[5].condiField == 6 ? false : true"
                            oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
                </div>
              </el-form-item>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="6">
            <el-form-item>
              <el-checkbox-group v-model="form.line[6].condiField">
                <el-checkbox :true-label="7"
                             false-label="-7">M(距今N天内的消费总金额)</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="18">
            <el-form-item label="">
              <div class="flex-between">
                <span>从</span>
                <el-input style="width: 45%"
                          v-model="form.line[6].value1"
                          :disabled="form.line[6].condiField == 7 ? false : true"
                          oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input style="width: 45%"
                          v-model="form.line[6].value2"
                          :disabled="form.line[6].condiField == 7 ? false : true"
                          oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="6">
            <el-form-item>
              <el-checkbox-group v-model="form.line[7].condiField">
                <el-checkbox :true-label="8"
                             false-label="-8">F(距今N天内的消费次数)</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="18">
            <el-form-item label="">
              <div class="flex-between">
                <span>从</span>
                <el-input style="width: 45%"
                          v-model="form.line[7].value1"
                          :disabled="form.line[7].condiField == 8 ? false : true"
                          oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input style="width: 45%"
                          v-model="form.line[7].value2"
                          :disabled="form.line[7].condiField == 8 ? false : true"
                          oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="6">
            <el-form-item>
              <el-checkbox-group v-model="form.line[8].condiField">
                <el-checkbox :true-label="9"
                             false-label="-9">今年消费总额</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="18">
            <el-form-item label="">
              <div class="flex-between">
                <span>从</span>
                <el-input style="width: 45%"
                          v-model="form.line[8].value1"
                          :disabled="form.line[8].condiField == 9 ? false : true"
                          oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input style="width: 45%"
                          v-model="form.line[8].value2"
                          :disabled="form.line[8].condiField == 9 ? false : true"
                          oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="6">
            <el-form-item>
              <el-checkbox-group v-model="form.line[9].condiField">
                <el-checkbox :true-label="10"
                             false-label="-10">今年消费次数</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="18">
            <el-form-item label="">
              <div class="flex-between">
                <span>从</span>
                <el-input style="width: 45%"
                          v-model="form.line[9].value1"
                          :disabled="form.line[9].condiField == 10 ? false : true"
                          oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input style="width: 45%"
                          v-model="form.line[9].value2"
                          :disabled="form.line[9].condiField == 10 ? false : true"
                          oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="6">
            <el-form-item>
              <el-checkbox-group v-model="form.line[10].condiField">
                <el-checkbox :true-label="11"
                             :false-label="-11">最近一年消费金额</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="18">
            <el-form-item label="">
              <div class="flex-between">
                <span>从</span>
                <el-input style="width: 45%"
                          v-model="form.line[10].value1"
                          :disabled="form.line[10].condiField == 11 ? false : true"
                          oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input style="width: 45%"
                          v-model="form.line[10].value2"
                          :disabled="form.line[10].condiField == 11 ? false : true"
                          oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <!-- 选择办卡门店弹窗 -->
      <div class="outlet">
        <el-dialog width="30%"
                   :visible.sync="selectStoreDialog"
                   title="GIADA Friends券库管理—选择门店"
                   append-to-body>
          <el-form size="mini"
                   label-width="80px">
            <el-row :gutter="50"
                    v-for="(item, index) in StoreSelectionList"
                    :key="index">
              <el-col :span="12"
                      v-for="(myitem, myindex) in item"
                      :key="myindex">
                <el-tree ref="tree"
                         v-if="myitem != undefined"
                         :data="[myitem]"
                         show-checkbox
                         node-key="ShopID"
                         highlight-current
                         default-expand-all
                         :default-checked-keys="xuanzhong"
                         :props="defaultProps">
                </el-tree>
              </el-col>
            </el-row>
            <!-- <el-row :gutter="50">
              <el-col :span="12">
                <el-tree
                  :data="selectShopData"
                  show-checkbox
                  node-key="id"
                  ref="tree"
                  :default-expand-all="true"
                  :default-checked-keys="treeKeys"
                  :props="defaultProps"
                  @check-change="currentChange"
                >
                </el-tree>
              </el-col>
            </el-row> -->
          </el-form>
          <div slot="footer"
               class="dialog-footer">
            <el-button @click="ComButtomStore">{{
              confirmButtonText
            }}</el-button>
            <el-button @click="selectStoreDialog = false">{{
              cancelButtonText
            }}</el-button>
          </div>
        </el-dialog>
      </div>
      <!-- 选择门店弹窗 -->
      <div class="outlet">
        <el-dialog width="30%"
                   :visible.sync="selectStoreDialog1"
                   title="GIADA Friends券库管理—选择门店"
                   append-to-body>
          <el-form size="mini"
                   label-width="80px">
            <el-row :gutter="50"
                    v-for="(item, index) in StoreSelectionList1"
                    :key="index">
              <el-col :span="12"
                      v-for="(myitem, myindex) in item"
                      :key="myindex">
                <el-tree ref="tree1"
                         v-if="myitem != undefined"
                         :data="[myitem]"
                         show-checkbox
                         node-key="ShopID"
                         highlight-current
                         default-expand-all
                         :default-checked-keys="xuanzhong1"
                         :props="defaultProps1">
                </el-tree>
              </el-col>
            </el-row>
            <!-- <el-row :gutter="50">
              <el-col :span="12">
                <el-tree
                  :data="selectShopData1"
                  show-checkbox
                  node-key="id"
                  ref="tree1"
                  :default-expand-all="true"
                  :default-checked-keys="treeKeys"
                  :props="defaultProps1"
                  @check-change="currentChange1"
                >
                </el-tree>
              </el-col>
            </el-row> -->
          </el-form>
          <div slot="footer"
               class="dialog-footer">
            <el-button @click="ComButtomStore1">{{
              confirmButtonText
            }}</el-button>
            <el-button @click="selectStoreDialog1 = false">{{
              cancelButtonText
            }}</el-button>
          </div>
        </el-dialog>
      </div>
    </el-card>
    <div slot="footer"
         class="dialog-footer">
      <el-button @click="save">{{ confirmButtonText }}</el-button>
      <el-button @click="cancel">{{ cancelButtonText }}</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { insertApi, updateApi, shopQueryRegionApi } from "@/api/marketing";
// import {getcpyNo} from "@/utils/auth"
// import { queryLSelectApi } from "@/api/user"
import { mapState } from "vuex";
// import Vue from 'vue';
export default {
  data () {
    return {
      id: "",
      multipleSelection: [],
      multipleSelection1: [],
      open: false,
      title: "",
      // outletVisible: false,
      // disabledMaintain: true,
      disableMTotal: true,
      disableFTotal: true,
      disabledYearTotal: true,
      disabledFrequency: true,
      disabledAYear: true,
      //分组
      fenZhuOptions: [
        {
          value: 0,
          label: "公共分组",
        },
        {
          value: 1,
          label: "个人分组",
        },
      ],
      // 选择门店数据
      StoreSelectionList: [],
      StoredataArray: [],
      xuanzhong: [],
      StoreSelectLength: 0,
      // 选择门店数据1
      StoreSelectionList1: [],
      StoredataArray1: [],
      xuanzhong1: [],
      StoreSelectLength1: 0,
      // -----------------------
      selectStoreDialog: false, //选择门店弹窗
      selectStoreDialog1: false, //选择门店弹窗
      selectShopData: [], // 选择门店树形图数据
      selectShopData1: [], // 选择门店树形图数据
      selectStore2: false,
      defaultProps: {
        children: "chlidren",
        label: "lable",
      },
      defaultProps1: {
        children: "chlidren",
        label: "lable",
      },
      treeKeys: [],
      form: {
        listOfSomeStoresl: [], // 选择门店
        listOfSomeStoreslStr: "", // 选择门店
        listOfSomeStoresl1: [], // 选择门店
        listOfSomeStoreslStr1: "", // 选择门店
        grpinfo: {
          custGrpName: "",
          grpKind: "",
          grpMode: 1,
          remark: "",
        },
        line: [
          {
            condiField: "",
            condiOP: "",
            value1: "",
            value2: "",
          },
          {
            condiField: "",
            condiOP: "",
            value1: "",
            value2: "",
          },
          {
            condiField: "",
            condiOP: "",
            value1: "",
            value2: "",
          },
          {
            condiField: "",
            condiOP: "",
            value1: "",
            value2: "",
          },
          {
            condiField: "",
            condiOP: "",
            value1: "",
            value2: "",
          },
          {
            condiField: "",
            condiOP: "",
            value1: "",
            value2: "",
          },
          {
            condiField: "",
            condiOP: "",
            value1: "",
            value2: "",
          },
          {
            condiField: "",
            condiOP: "",
            value1: "",
            value2: "",
          },
          {
            condiField: "",
            condiOP: "",
            value1: "",
            value2: "",
          },
          {
            condiField: "",
            condiOP: "",
            value1: "",
            value2: "",
          },
          {
            condiField: "",
            condiOP: "",
            value1: "",
            value2: "",
          },
        ],
      },
      //办卡门店
      newApp: [],
      //维护门店
      newArr: [],
      checkbooksData: [],
      levelList: [],
      // 验证规则
      // rules: {
      //   custGrpName: [
      //     { required: true, message: "请输入分组名称", trigger: "blur" },
      //     {
      //       min: 1,
      //       max: 15,
      //       message: "长度在 1 到 15 个字符",
      //       trigger: "blur",
      //     },
      //   ],
      //   grpKind: [
      //     { required: true, message: "请选择分组类型", trigger: "change" },
      //   ],
      //   remark: [
      //     { required: true, message: "请输入分组描述", trigger: "blur" },
      //     {
      //       min: 1,
      //       max: 20,
      //       message: "长度在 1 到 20 个字符",
      //       trigger: "blur",
      //     },
      //   ],
      // },
      arrTreeID: [],
      arrTreeID1: [],
      levelFormData: {},
      labelValue: "1",
    };
  },
  created () {

    // this.leveCast()
    this.shopRegionList();
  },
  computed: {
    ...mapState(["confirmButtonText", "cancelButtonText"]),
  },
  // watch: {
  //   form: {
  //     handler(newval, oldvalue) {
  //       console.log("------");
  //       // if (newval[0].condiField == 1) {
  //       //   this.form.line[0].value2 = 1;
  //       // }
  //     },
  //   },
  //   deep: true,
  //   immediate: true,
  // },
  methods: {
    // 办卡门店
    // 选择门店确定事件
    ComButtomStore () {
      //获取已选择的门店数据
      this.newApp = [];
      this.form.listOfSomeStoreslStr = "";
      for (let index = 0; index < this.StoreSelectLength; index++) {
        let item = this.$refs.tree[index].getCheckedNodes();
        if (item.length == this.StoredataArray[index].chlidren.length + 1) {
          this.newApp.push(
            ...this.StoredataArray[index].chlidren
          );
        } else {
          this.newApp.push(...item);
        }
      }
      // this.form.listOfSomeStoresl.forEach((item) => {
      //   this.form.listOfSomeStoreslStr += `${item.lable}\n`;
      // });
      // this.form.listOfSomeStoreslStr = this.form.listOfSomeStoreslStr.substring(
      //   0,
      //   this.form.listOfSomeStoreslStr.length - 2
      // );
      this.xuanzhong = [];
      for (let i = 0; i < this.newApp.length; i++) {
        this.xuanzhong.push(this.newApp[i].id);
      }
      this.selectStoreDialog = false;
    },
    // 维护门店
    ComButtomStore1 () {
      //获取已选择的门店数据
      this.newArr = [];
      this.form.listOfSomeStoreslStr1 = "";
      for (let index = 0; index < this.StoreSelectLength1; index++) {
        let item = this.$refs.tree1[index].getCheckedNodes();
        if (item.length == this.StoredataArray1[index].chlidren.length + 1) {
          this.newArr.push(
            ...this.StoredataArray1[index].chlidren
          );
        } else {
          this.newArr.push(...item);
        }
      }
      this.newArr.forEach((item) => {
        this.form.listOfSomeStoreslStr1 += `${item.lable}\n`;
      });
      this.form.listOfSomeStoreslStr1 = this.form.listOfSomeStoreslStr1.substring(
        0,
        this.form.listOfSomeStoreslStr1.length - 2
      );
      this.xuanzhong1 = [];
      for (let i = 0; i < this.newArr.length; i++) {
        this.xuanzhong1.push(this.newArr[i].id);
      }
      this.selectStoreDialog1 = false;
    },
    //等级获取
    // leveCast () {
    //   queryLSelectApi().then((res) => {
    //     console.log(res);
    //     if (res.data.isDefaultLvl === true) {
    //       this.checkbooksData.push(res.data.levelID)
    //     }
    //   });
    // },
    // queryLSelectApi({ cpyNO: getcpyNo() }).then((res) => {
    //   this.$refs.conDialogRef.checkbooksData = res.data

    // });
    leveCast () {
      // console.log(this.form.line[0].condiField, this.form.line[0].value2);
      if (this.form.line[0].condiField != 1) {
        this.newApp = []
      }

      if (this.form.line[0].condiField == 1) {
        this.form.line[0].value2 = "1";
        this.form = Object.assign(this.form, this.form);
        // console.log(this.form, "----");
      } else {
        this.form.line[0].value2 = 0;
        this.form = Object.assign(this.form, this.form);
      }
    },
    levecur () {
      // console.log(this.form.line[1].value2);
      if (this.form.line[1].condiField != 2) {
        this.newArr = []
      }
      if (this.form.line[1].condiField == 2) {
        this.form.line[1].value2 = "1";
        this.form = Object.assign(this.form, this.form);
        // console.log(this.form, "----");
      } else {
        this.form.line[1].value2 = 0;
        this.form = Object.assign(this.form, this.form);
      }
    },
    updata (data) {
      let line = [
        {
          condiField: "",
          condiOP: "",
          value1: "",
          value2: "",
        },
        {
          condiField: "",
          condiOP: "",
          value1: "",
          value2: "",
        },
        {
          condiField: "",
          condiOP: "",
          value1: "",
          value2: "",
        },
        {
          condiField: "",
          condiOP: "",
          value1: "",
          value2: "",
        },
        {
          condiField: "",
          condiOP: "",
          value1: "",
          value2: "",
        },
        {
          condiField: "",
          condiOP: "",
          value1: "",
          value2: "",
        },
        {
          condiField: "",
          condiOP: "",
          value1: "",
          value2: "",
        },
        {
          condiField: "",
          condiOP: "",
          value1: "",
          value2: "",
        },
        {
          condiField: "",
          condiOP: "",
          value1: "",
          value2: "",
        },
        {
          condiField: "",
          condiOP: "",
          value1: "",
          value2: "",
        },
        {
          condiField: "",
          condiOP: "",
          value1: "",
          value2: "",
        },
      ];

      // console.log(this.checkbooksData);
      // // if (this.checkbooksData.isDefaultLvl===true) {
      // //   this.checkbooksData.push()
      // // }
      // this.checkbooksData.forEach((item) => {
      //   if (item.isDefaultLvl === true) {
      //     this.levelList.push(item.levelID);
      //   }
      // });

      // let curItem = data.line
      this.form = data;
      for (let i = 0; i < data.line.length; i++) {
        console.log(i);
        line[data.line[i].condiField - 1] = data.line[i];
      }
      this.$set(this.form, "line", line);
      let cuarItem = line[2].value1.split(';')
      this.levelList = cuarItem.map(Number)
      // let len = data.line.length
      // for (let i = 0; i < 11 - len; i++) {
      //   let object = {
      //   }
      //   object.condiField = len + i + 2 + ''
      //   data.line.push(object)
      // }
      let custGrpLineShopVO = [];
      let custGrpLineShopVO1 = [];

      data.shops.forEach((item) => {
        if (item.condiField === 1) {
          custGrpLineShopVO.push(item.custGrpLineShopVO);
        }
        if (item.condiField === 2) {
          custGrpLineShopVO1.push(item.custGrpLineShopVO);
        }
      });

      if (custGrpLineShopVO.length > 0) {
        for (let i = 0; i < custGrpLineShopVO[0].length; i++) {
          let keyMap = {
            lable: custGrpLineShopVO[0][i].shopName,
            id: custGrpLineShopVO[0][i].shopID,
          };
          this.newApp.push(keyMap);
        }
      }

      if (custGrpLineShopVO1.length > 0) {
        for (let i = 0; i < custGrpLineShopVO1[0].length; i++) {
          let keyMap = {
            lable: custGrpLineShopVO1[0][i].shopName,
            id: custGrpLineShopVO1[0][i].shopID,
          };
          this.newArr.push(keyMap);
        }
      }

    },
    handleCheckedCitiesChange () { },
    //tree
    // currentChange(val) {
    //   // this.multipleSelection  这个数组用来存储所有半选的节点和全选的节点  用于保存的时候将数据传给后台
    //   // 将半选和全选的节点全都存储在一个数组里面   concat 方法是合并(全选和半选)两个数组
    //   this.multipleSelection = this.$refs.tree.getCheckedNodes();
    //   this.newApp = this.$refs.tree.getCheckedNodes();

    //   this.form.line[0].value1 = this.newApp;
    //   // console.log(this.form.line[0]);
    //   this.arrTreeID = this.form.line[0].value1.map((item) => {
    //     return this.arrTreeID.push(item.id);
    //   });
    // },
    // currentChange1(val) {
    //   // this.multipleSelection  这个数组用来存储所有半选的节点和全选的节点  用于保存的时候将数据传给后台
    //   // 将半选和全选的节点全都存储在一个数组里面   concat 方法是合并(全选和半选)两个数组
    //   this.multipleSelection1 = this.$refs.tree1.getCheckedNodes();
    //   this.newArr = this.$refs.tree1.getCheckedNodes();
    //   // this.newArr = this.multipleSelection1
    //   this.form.line[1].value1 = this.newArr;
    //   // console.log(this.form.line[1]);
    //   // console.log(this.multipleSelection1,"this.multipleSelection")
    //   this.arrTreeID1 = this.form.line[1].value1.map((item) => {
    //     return this.arrTreeID1.push(item.id);
    //   });
    // },
    // 遍历找出所有子节点
    // findAllChildren(data, arr) {
    //   data.forEach((item, index) => {
    //     if (item.children.length !== 0) {
    //       this.findAllChildren(item.children, arr);
    //     }
    //   });
    // },
    // 选择门店tree数据
    shopRegionList () {
      shopQueryRegionApi().then((res) => {
        let arr1 = [],
          arr2 = [];
        let add1 = [],
          add2 = [];
        if (res.success) {
          res.data.forEach((item) => {
            // 办卡门店
            if (item.chlidren.length > 0) this.StoredataArray.push(item);
            // 维护门店
            if (item.chlidren.length > 0) this.StoredataArray1.push(item);
          });
          // 办卡门店
          this.StoredataArray.forEach((item, index) => {
            item.chlidren.forEach((item) => {
              item.ShopID = item.id;
            });
            this.StoreSelectLength += 1;
            if (index % 2 == 0) {
              arr1.push(item);
            } else {
              arr2.push(item);
            }
          });
          // 维护门店
          this.StoredataArray1.forEach((item, index) => {
            item.chlidren.forEach((item) => {
              item.ShopID = item.id;
            });
            this.StoreSelectLength1 += 1;
            if (index % 2 == 0) {
              add1.push(item);
            } else {
              add2.push(item);
            }
          });
          // 办卡门店
          this.StoreSelectionList = arr1.map((key, value) => [
            key,
            arr2[value],
          ]);
          // 维护门店
          this.StoreSelectionList1 = add1.map((key, value) => [
            key,
            add2[value],
          ]);

        } else {
          this.$message.error(res.message);
        }
      });
    },

    closeDialog () {
      // this.form = "";
      this.xuanzhong = [],
        this.xuanzhong1 = [],
        this.form = {
          grpinfo: {
            custGrpName: "",
            grpKind: "",
            grpMode: 1,
            remark: "",
          },
          line: [
            {
              condiField: "",
              condiOP: "",
              value1: "",
              value2: "",
            },
            {
              condiField: "",
              condiOP: "",
              value1: "",
              value2: "",
            },
            {
              condiField: "",
              condiOP: "",
              value1: undefined,
              value2: "",
            },
            {
              condiField: "",
              condiOP: "",
              value1: "",
              value2: "",
            },
            {
              condiField: "",
              condiOP: "",
              value1: "",
              value2: "",
            },
            {
              condiField: "",
              condiOP: "",
              value1: "",
              value2: "",
            },
            {
              condiField: "",
              condiOP: "",
              value1: "",
              value2: "",
            },
            {
              condiField: "",
              condiOP: "",
              value1: "",
              value2: "",
            },
            {
              condiField: "",
              condiOP: "",
              value1: "",
              value2: "",
            },
            {
              condiField: "",
              condiOP: "",
              value1: "",
              value2: "",
            },
            {
              condiField: "",
              condiOP: "",
              value1: "",
              value2: "",
            },
          ],

          shops: [],

        };
      this.$refs.ruleForm.resetFields()
      this.open = false;
      this.newApp = [];
      this.newArr = [];
      this.levelList = []
    },
    // 取消
    cancel () {
      this.$refs.ruleForm.resetFields()
      this.open = false;
      this.newApp = [];
      this.newArr = [];
      this.levelList = []
    },
    handleClose () {
      this.open = false;
    },

    // 选择办卡门店
    selectStoreBtn1 () {
      this.selectStoreDialog = true;
    },
    //选择维护门店
    selectStoreBtn2 () {
      this.selectStoreDialog1 = true;
    },
    handVant (val) {
      if (val == -3) {
        this.levelList = []
      }
    },
    // 创建
    insertSave () {
      let shopID = [];
      if (this.newApp.length > 0) {
        // 处理选择部分门店
        this.newApp.forEach((item) => {
          shopID.push(item.id);
        });
      }
      let shopID1 = [];
      if (this.newArr.length > 0) {
        // 处理选择部分门店
        this.newArr.forEach((item) => {
          shopID1.push(item.id);
        });
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let queryInfo = {
            custGrpName: this.form.grpinfo.custGrpName,
            grpKind: this.form.grpinfo.grpKind,
            grpMode: 1,
            remark: this.form.grpinfo.remark,
          };
          let queryBody = [
            {
              condiField: this.form.line[0].condiField ? 1 : "", // 勾选传1，不勾选传空
              // condiOP: 7,
              condiOP:
                this.form.line[0].value2 == 1
                  ? 7
                  : this.form.line[0].value2 == 2
                    ? 8
                    : "",
              value1: shopID.join(";"),
              value2: this.form.line[0].value2, // 1包含 2排除
            },
            {
              condiField: this.form.line[1].condiField ? 2 : "",
              // condiOP: 7,
              condiOP:
                this.form.line[1].value2 == 1
                  ? 7
                  : this.form.line[1].value2 == 2
                    ? 8
                    : "",
              value1: shopID1.join(";"), // 10
              value2: this.form.line[1].value2, // 20
            },
            {
              condiField: this.form.line[2].condiField ? 3 : "", // 会员等级
              // condiOP: 6,
              condiOP: this.form.line[2].condiField == 3 ? 7 : "",
              value1: this.levelList.join(";"),
              value2: this.form.line[2].value2,
            },
            {
              condiField: this.form.line[3].condiField ? 4 : "", // 会员积分
              // condiOP: 6,
              condiOP: this.form.line[3].condiField == 4 ? 6 : "",
              value1: this.form.line[3].value1,
              value2: this.form.line[3].value2,
            },
            {
              condiField: this.form.line[4].condiField ? 5 : "",
              // condiOP: 6,
              condiOP: this.form.line[4].condiField == 5 ? 6 : "",
              value1: this.form.line[4].value1,
              value2: this.form.line[4].value2,
            },
            {
              condiField: this.form.line[5].condiField ? 6 : "",
              // condiOP: 6,
              condiOP: this.form.line[5].condiField == 6 ? 6 : "",
              value1: this.form.line[5].value1,
              value2: this.form.line[5].value2,
            },
            {
              condiField: this.form.line[6].condiField ? 7 : "",
              // condiOP: 6,
              condiOP: this.form.line[6].condiField == 7 ? 6 : "",
              value1: this.form.line[6].value1,
              value2: this.form.line[6].value2,
            },
            {
              condiField: this.form.line[7].condiField ? 8 : "",
              // condiOP: 6,
              condiOP: this.form.line[7].condiField == 8 ? 6 : "",
              value1: this.form.line[7].value1,
              value2: this.form.line[7].value2,
            },
            {
              condiField: this.form.line[8].condiField ? 9 : "",
              // condiOP: 6,
              condiOP: this.form.line[8].condiField == 9 ? 6 : "",
              value1: this.form.line[8].value1,
              value2: this.form.line[8].value2,
            },
            {
              condiField: this.form.line[9].condiField ? 10 : "",
              // condiOP: 6,
              condiOP: this.form.line[9].condiField == 10 ? 6 : "",
              value1: this.form.line[9].value1,
              value2: this.form.line[9].value2,
            },
            {
              condiField: this.form.line[10].condiField ? 11 : "",
              // condiOP: 6,
              condiOP: this.form.line[10].condiField == 11 ? 6 : "",
              value1: this.form.line[10].value1,
              value2: this.form.line[10].value2,
            },
          ];
          if (this.form.line[3].condiField == 4) {
            if (!this.form.line[3].value1 || !this.form.line[3].value2) {
              return this.$message.warning("请检查会员积分是否输入完整!");
            }
          }
          if (this.form.line[4].condiField == 5) {
            if (!this.form.line[4].value1 || !this.form.line[4].value2) {
              return this.$message.warning(
                "请检查首次升级VIC距今天数是否输入完整!"
              );
            }
          }
          if (this.form.line[5].condiField == 6) {
            if (!this.form.line[5].value1 || !this.form.line[5].value2) {
              return this.$message.warning(
                "请检查R(最近消费日距今天数)是否输入完整!"
              );
            }
          }
          if (this.form.line[6].condiField == 7) {
            if (!this.form.line[6].value1 || !this.form.line[6].value2) {
              return this.$message.warning(
                "请检查M(距今N天内的消费总金额)是否输入完整!"
              );
            }
          }
          if (this.form.line[7].condiField == 8) {
            if (!this.form.line[7].value1 || !this.form.line[7].value2) {
              return this.$message.warning(
                "请检查F(距今N天内的消费次数)是否输入完整!"
              );
            }
          }
          if (this.form.line[8].condiField == 9) {
            if (!this.form.line[8].value1 || !this.form.line[8].value2) {
              return this.$message.warning("请检查今年消费总额是否输入完整!");
            }
          }
          if (this.form.line[9].condiField == 10) {
            if (!this.form.line[9].value1 || !this.form.line[9].value2) {
              return this.$message.warning("请检查今年消费次数是否输入完整!");
            }
          }
          if (this.form.line[10].condiField == 11) {
            if (!this.form.line[10].value1 || !this.form.line[10].value2) {
              return this.$message.warning(
                "请检查最近一年消费金额是否输入完整!"
              );
            }
          }
          if (this.form.line[0].condiField === 1 && this.newApp == false) {
            return this.$message.warning('请选择办卡具体门店！')
          } else if (this.form.line[1].condiField === 2 && this.newArr == false) {
            return this.$message.warning('请选择维护具体门店！')
          }
          else if (this.form.line[2].condiField === 3 && this.levelList.length == 0) {
            return this.$message.warning('请勾选具体会员等级！')
          }
          insertApi(queryInfo, queryBody).then((res) => {
            if (res.success) {
              if (this.id == 2) {
                this.$message.success("复制数据成功!");
              } else {
                this.$message.success("新增数据成功!");
              }
              this.newApp = [];
              this.newArr = [];
              this.open = false;
              this.$parent.searchList();
            }
          });
        }
      });
    },
    // 修改
    updateSave () {
      let shopID = [];
      if (this.newApp.length > 0) {
        // 处理选择部分门店
        this.newApp.forEach((item) => {
          shopID.push(item.id);
        });
      }
      let shopID1 = [];
      if (this.newArr.length > 0) {
        // 处理选择部分门店
        this.newArr.forEach((item) => {
          shopID1.push(item.id);
        });
      }
      let modifyInfo = {
        // customerGrpID: localStorage.getItem("lookId"),
        customerGrpID: this.form.grpinfo.customerGrpID,
        custGrpName: this.form.grpinfo.custGrpName,
        grpKind: this.form.grpinfo.grpKind,
        grpMode: 1,
        remark: this.form.grpinfo.remark,
      };
      let modifyBody = [
        {
          condiField: this.form.line[0].condiField ? 1 : "", // 勾选传1，不勾选传空
          // condiOP: 7,
          condiOP:
            this.form.line[0].value2 == 1
              ? 7
              : this.form.line[0].value2 == 2
                ? 8
                : "",
          value1: shopID.join(";"),
          value2: this.form.line[0].value2, // 1包含 2排除
        },
        {
          condiField: this.form.line[1].condiField ? 2 : "",
          // condiOP: 7,
          condiOP:
            this.form.line[1].value2 == 1
              ? 7
              : this.form.line[1].value2 == 2
                ? 8
                : "",
          value1: shopID1.join(";"), // 10
          value2: this.form.line[1].value2, // 20
        },
        {
          condiField: this.form.line[2].condiField ? 3 : "", // 会员等级
          // condiOP: 6,
          condiOP: this.form.line[2].condiField == 3 ? 7 : "",
          value1: this.levelList.join(";"),
          value2: this.form.line[2].value2,
        },
        {
          condiField: this.form.line[3].condiField ? 4 : "", // 会员积分
          // condiOP: 6,
          condiOP: this.form.line[3].condiField == 4 ? 6 : "",
          value1: this.form.line[3].value1,
          value2: this.form.line[3].value2,
        },
        {
          condiField: this.form.line[4].condiField ? 5 : "", //首次升级VIC距今天数
          // condiOP: 6,
          condiOP: this.form.line[4].condiField == 5 ? 6 : "",
          value1: this.form.line[4].value1,
          value2: this.form.line[4].value2,
        },
        {
          condiField: this.form.line[5].condiField ? 6 : "", //最近未消费天数
          // condiOP: 6,
          condiOP: this.form.line[5].condiField == 6 ? 6 : "",
          value1: this.form.line[5].value1,
          value2: this.form.line[5].value2,
        },
        {
          condiField: this.form.line[6].condiField ? 7 : "", //M指定日期内的消费金额
          // condiOP: 6,
          condiOP: this.form.line[6].condiField == 7 ? 6 : "",
          value1: this.form.line[6].value1,
          value2: this.form.line[6].value2,
        },
        {
          condiField: this.form.line[7].condiField ? 8 : "", //F指定日期内的消费次数
          // condiOP: 6,
          condiOP: this.form.line[7].condiField == 8 ? 6 : "",
          value1: this.form.line[7].value1,
          value2: this.form.line[7].value2,
        },
        {
          condiField: this.form.line[8].condiField ? 9 : "", //今年消费金额
          // condiOP: 6,
          condiOP: this.form.line[8].condiField == 9 ? 6 : "",
          value1: this.form.line[8].value1,
          value2: this.form.line[8].value2,
        },
        {
          condiField: this.form.line[9].condiField ? 10 : "", //今年消费次数
          // condiOP: 6,
          condiOP: this.form.line[9].condiField == 10 ? 6 : "",
          value1: this.form.line[9].value1,
          value2: this.form.line[9].value2,
        },
        {
          condiField: this.form.line[10].condiField ? 11 : "", //最近一年消费
          // condiOP: 6,
          condiOP: this.form.line[10].condiField == 11 ? 6 : "",
          value1: this.form.line[10].value1,
          value2: this.form.line[10].value2,
        },
      ];
      if (this.form.line[3].condiField == 4) {
        if (!this.form.line[3].value1 || !this.form.line[3].value2) {
          return this.$message.warning("请检查会员积分是否输入完整");
        }
      }
      if (this.form.line[4].condiField == 5) {
        if (!this.form.line[4].value1 || !this.form.line[4].value2) {
          return this.$message.warning(
            "请检查首次升级VIC距今天数是否输入完整!"
          );
        }
      }
      if (this.form.line[5].condiField == 6) {
        if (!this.form.line[5].value1 || !this.form.line[5].value2) {
          return this.$message.warning(
            "请检查R(最近消费日距今天数)是否输入完整!"
          );
        }
      }
      if (this.form.line[6].condiField == 7) {
        if (!this.form.line[6].value1 || !this.form.line[6].value2) {
          return this.$message.warning(
            "请检查M(距今N天内的消费总金额)是否输入完整!"
          );
        }
      }
      if (this.form.line[7].condiField == 8) {
        if (!this.form.line[7].value1 || !this.form.line[7].value2) {
          return this.$message.warning(
            "请检查F(距今N天内的消费次数)是否输入完整!"
          );
        }
      }
      if (this.form.line[8].condiField == 9) {
        if (!this.form.line[8].value1 || !this.form.line[8].value2) {
          return this.$message.warning("请检查今年消费总额是否输入完整!");
        }
      }
      if (this.form.line[9].condiField == 10) {
        if (!this.form.line[9].value1 || !this.form.line[9].value2) {
          return this.$message.warning("请检查今年消费次数是否输入完整!");
        }
      }
      if (this.form.line[10].condiField == 11) {
        if (!this.form.line[10].value1 || !this.form.line[10].value2) {
          return this.$message.warning("请检查最近一年消费金额是否输入完整!");
        }
      }
      if (this.form.line[0].condiField === 1 && this.newApp == false) {
        return this.$message.warning('请选择办卡具体门店！')
      } else if (this.form.line[1].condiField === 2 && this.newArr == false) {
        return this.$message.warning('请选择维护具体门店！')
      }
      else if (this.form.line[2].condiField === 3 && this.levelList.length == 0) {
        return this.$message.warning('请勾选具体会员等级！')
      }
      updateApi(modifyInfo, modifyBody).then((res) => {
        if (res.success) {
          this.$message.success("修改数据成功!");
          this.open = false;
          this.$parent.searchList();
        }
      });
    },
    save () {
      if (this.id == 1 || this.id == 2) {
        this.insertSave();
      }
      // else if (this.id == 2) {
      //   this.$message.success("保存数据成功");
      //   this.$parent.goToConditional(1);
      // }
      else {
        this.updateSave();
      }
    },
  },
  // 保存
};
</script>
<style lang="scss" scoped>
header {
  font-size: 20px;
  font-weight: 600;
  margin: 20px 0;
}
.dialog-footer {
  display: flex;
  justify-content: center;
}
.xzBox {
  height: 100px;
  width: 100%;
  border: 1px solid #ccc;
  overflow-y: auto;
}
</style>
